import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAdd,
  faAngleRight,
  faAnglesLeft,
  faAnglesRight,
  faArrowDown,
  faArrowLeft,
  faArrowsAltV,
  faArrowUp,
  faBook,
  faChartLine,
  faCheck,
  faCheckDouble,
  faChevronLeft,
  faChevronRight,
  faClock,
  faClose,
  faDatabase,
  faDesktop,
  faDownload,
  faEye,
  faEyeSlash,
  faFileExport,
  faFolder,
  faGear,
  faGlobe,
  faHome,
  faInfo,
  faKeyboard,
  faLanguage,
  faLightbulb,
  faLink,
  faLock,
  faMagic,
  faMagnifyingGlass,
  faMicrophone,
  faPenToSquare,
  faPeopleRobbery,
  faPersonWalkingWithCane,
  faRefresh,
  faRightLeft,
  faRotate,
  faShield,
  faSpinner,
  faStepForward,
  faStopwatch,
  faStopwatch20,
  faSwatchbook,
  faTag,
  faTimeline,
  faTrash,
  faTriangleExclamation,
  faUpload,
  faUser,
  faUserPlus,
  faUsers,
  faWarning,
  faX,
} from "@fortawesome/free-solid-svg-icons";
import { keyboard } from "@testing-library/user-event/dist/keyboard";

interface IconProps {
  variant?: keyof typeof variants; // Si pas de variant précisé, la couleur de l'icone est déterminée par les parents
  hoveredVariant?: keyof typeof variants;
  icon: keyof typeof icons;
  children?: React.ReactNode;
}

export const icons = {
  user: faUser,
  translation: faBook,
  translate: faLanguage,
  phases: faArrowsAltV,
  users: faUsers,
  modify: faPenToSquare,
  delete: faTrash,
  view: faMagnifyingGlass,
  add: faUserPlus,
  close: faClose,
  download: faDownload,
  superieur: faChevronRight,
  inferieur: faChevronLeft,
  doubleInf: faAnglesLeft,
  doubleSup: faAnglesRight,
  angleRight: faAngleRight,
  chain: faLink,
  gear: faGear,
  lightbulb: faLightbulb,
  database: faDatabase,
  desktop: faDesktop,
  folder: faFolder,
  step: faStepForward,
  home: faHome,
  process: faRightLeft,
  timeline: faTimeline,
  eye: faEye,
  eyeSlash: faEyeSlash,
  check: faCheck,
  uncheck: faX,
  doubleCheck: faCheckDouble,
  rotate: faRotate,
  upload: faUpload,
  triangleExclamation: faTriangleExclamation,
  left: faArrowLeft,
  export: faFileExport,
  plus: faAdd,
  shield: faShield,
  lock: faLock,
  refresh: faRefresh,
  globe: faGlobe,
  warn: faWarning,
  down: faArrowDown,
  up: faArrowUp,
  clock: faClock,
  tag: faTag,
  chart: faChartLine,
  analytics: faChartLine,
  magic: faMagic,
  mic: faMicrophone,
  keyboard: faKeyboard,
  info: faInfo,
};

const variants: { [key: string]: string } = {
  dark: "text-primary-dark",
  light: "text-secondary-light",
};

const Icon: React.FC<IconProps> = ({ variant = "", icon, hoveredVariant = variant, children }) => {
  const classes = `p-1 transition duration-200  ${variants[variant]} ${
    hoveredVariant ? "hover:" + variants[hoveredVariant] : ""
  }`;
  return (
    <div className="flex items-center justify-center gap-2">
      <FontAwesomeIcon icon={icons[icon]} className={classes} size="lg" />
      {children && <span> {children} </span>}
    </div>
  );
};

export default Icon;
